import { render, staticRenderFns } from "./BaseFileViewer.vue?vue&type=template&id=a1a96286&scoped=true"
import script from "./BaseFileViewer.vue?vue&type=script&lang=js"
export * from "./BaseFileViewer.vue?vue&type=script&lang=js"
import style0 from "./BaseFileViewer.vue?vue&type=style&index=0&id=a1a96286&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1a96286",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})
